(function () {
  'use strict';
  if (typeof CSSScopeRule !== 'undefined') return;
  function closingBrace(text, start) {
    var depth = 1, quote = '', comment = false;
    for (var i = start + 1; i < text.length; i++) {
      var c = text[i], next = text[i + 1];
      if (comment) { if (c === '*' && next === '/') { comment = false; i++; } continue; }
      if (quote) { if (c === '\\') i++; else if (c === quote) quote = ''; continue; }
      if (c === '/' && next === '*') { comment = true; i++; continue; }
      if (c === '"' || c === "'") { quote = c; continue; }
      if (c === '{') depth++;
      if (c === '}' && --depth === 0) return i;
    }
    throw new Error('Unclosed scoped stylesheet');
  }
  function selectors(text) {
    var parts = [], start = 0, depth = 0, quote = '';
    for (var i = 0; i < text.length; i++) {
      var c = text[i];
      if (quote) { if (c === '\\') i++; else if (c === quote) quote = ''; continue; }
      if (c === '"' || c === "'") { quote = c; continue; }
      if (c === '(' || c === '[') depth++;
      if (c === ')' || c === ']') depth--;
      if (c === ',' && !depth) { parts.push(text.slice(start, i)); start = i + 1; }
    }
    parts.push(text.slice(start));
    return parts;
  }
  function rulesText(rules, root) {
    return Array.from(rules).map(function (rule) {
      if (rule.type === 1) {
        var selector = selectors(rule.selectorText).map(function (part) {
          part = part.trim();
          return /:scope\b/.test(part)
            ? part.replace(/:scope\b/g, ':where(' + root + '):not(.nuoro-scope-excluded)')
            : ':where(' + root + ') ' + part;
        }).join(',');
        return selector + '{' + rule.style.cssText + '}';
      }
      if (rule.cssRules && !/keyframes/i.test(rule.cssText.slice(0, 40))) {
        return rule.cssText.slice(0, rule.cssText.indexOf('{') + 1) + rulesText(rule.cssRules, root) + '}';
      }
      return rule.cssText;
    }).join('\n');
  }
  function convert(style) {
    if (style.dataset.nuoroScopeFallback || style.textContent.indexOf('@scope') < 0) return;
    var source = style.textContent, pattern = /@scope\s*\(([^{}]+)\)\s*\{/g, match, cursor = 0, output = '';
    var parser = document.createElement('style');
    parser.media = 'not all';
    document.head.appendChild(parser);
    try {
      while ((match = pattern.exec(source))) {
        var open = pattern.lastIndex - 1, end = closingBrace(source, open);
        output += source.slice(cursor, match.index);
        parser.textContent = source.slice(open + 1, end).replace(/\.block:has\(#freqs\)/g, '.nuoro-frequency-block');
        output += rulesText(parser.sheet.cssRules, match[1].trim());
        cursor = end + 1;
        pattern.lastIndex = cursor;
      }
      output += source.slice(cursor);
      style.textContent = output;
      style.dataset.nuoroScopeFallback = 'true';
    } finally { parser.remove(); }
  }
  function apply() {
    document.querySelectorAll('.nuoro-module #freqs').forEach(function (el) {
      var block = el.closest('.block'); if (block) block.classList.add('nuoro-frequency-block');
    });
    document.querySelectorAll('style').forEach(function (style) {
      try { convert(style); } catch (error) { console.error('NUORO style compatibility', error); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply, {once:true});
  else apply();
  document.addEventListener('shopify:section:load', apply);
})();

/* Native NUORO module runtime. No eval, iframe or prototype cart. */
(function(){
'use strict';
document.addEventListener('pointerdown',function(){document.documentElement.dataset.nuoroInput='pointer';},true);
document.addEventListener('keydown',function(event){if(['Tab','Enter',' ','Escape','ArrowUp','ArrowDown','ArrowLeft','ArrowRight'].includes(event.key))document.documentElement.dataset.nuoroInput='keyboard';},true);
window.NuoroAsset=function(path){return window.NuoroAssets[path.split('?')[0]]||path;};
window.NuoroImageURL=function(source,width){
 const url=new URL(source,location.href);
 if(!/\/cdn\/shop\//.test(url.pathname)||/\.svg$/i.test(url.pathname))return source;
 url.searchParams.set('width',width);return url.href;
};
window.NuoroResponsiveImage=function(img,source,sizes,widths){
 if(!source||/\.svg(?:\?|$)/i.test(source))return;
 const candidates=widths||[240,400,640,800,1000,1200];
 const measured=img.getBoundingClientRect().width;
 img.sizes=sizes||(measured?Math.ceil(measured)+'px':'(max-width:767px) calc(100vw - 32px), 50vw');
 img.srcset=candidates.map(width=>window.NuoroImageURL(source,width)+' '+width+'w').join(', ');
 img.decoding='async';
 img.src=window.NuoroImageURL(source,candidates[Math.min(2,candidates.length-1)]);
};
const imageSizer=new ResizeObserver(entries=>entries.forEach(entry=>{
 const img=entry.target.querySelector('img')||entry.target;
 if(entry.contentRect.width>0)img.sizes=Math.ceil(entry.contentRect.width)+'px';
}));
window.NuoroModules=window.NuoroModules||{};
window.NuoroModuleDocument=function(root){
 const real=document;
 const normalize=s=>s.replace(/\bbody\s+/g,'').replace(/^body$/,'__nuoro_root__');
 return new Proxy(real,{get(target,key){
  if(key==='body'||key==='documentElement'||key==='head')return root;
  if(key==='querySelector')return s=>s==='body'||s==='html'||s===':root'?root:root.querySelector(normalize(s));
  if(key==='querySelectorAll')return s=>s==='body'||s==='html'||s===':root'?[root]:root.querySelectorAll(normalize(s));
  if(key==='getElementById')return id=>root.querySelector('#'+CSS.escape(id));
  if(key==='addEventListener'||key==='removeEventListener')return root[key].bind(root);
  const value=Reflect.get(target,key,target);return typeof value==='function'?value.bind(target):value;
 }});
};
window.NuoroBoot=function(key){
 const initialize=window.NuoroModules[key];if(!initialize)return;
 document.querySelectorAll('[data-nuoro-key="'+key+'"]').forEach(root=>{
  if(root.dataset.nuoroReady)return;root.dataset.nuoroReady='true';
  try{initialize(root);root.querySelectorAll('img:not([srcset])').forEach(img=>{window.NuoroResponsiveImage(img,img.getAttribute('src'));imageSizer.observe(img);});}catch(error){root.dataset.nuoroError=error.message;console.error('NUORO module '+key,error);}
 });
};
let menuTrigger = null;
let menuPreviousOverflow = '';
let menuRestoreFocus = true;
function closeMobileMenu(restoreFocus = true) {
 const menu = document.getElementById('NuoroMobileNavigation');
 if (!menu?.open) return;
 menuRestoreFocus = restoreFocus;
 menu.close();
}
function createMobileMenu() {
 const menu = document.createElement('dialog');
 if (typeof menu.showModal !== 'function') {
  menu.style.display = 'none';
  menu.setAttribute('role', 'dialog');
  menu.setAttribute('aria-modal', 'true');
  menu.showModal = function () {
   menu.setAttribute('open', ''); menu.open = true; menu.style.display = 'flex';
  };
  menu.close = function () {
   menu.removeAttribute('open'); menu.open = false; menu.style.display = 'none';
   menu.dispatchEvent(new Event('close'));
  };
  menu.addEventListener('keydown', function (event) {
   if (event.key === 'Escape') { event.preventDefault(); closeMobileMenu(); }
   if (event.key !== 'Tab') return;
   const focusable = Array.from(menu.querySelectorAll('a[href],button')).filter(el => !el.disabled && el.getClientRects().length);
   const first = focusable[0], last = focusable[focusable.length - 1];
   if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
   else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
 }
 menu.id = 'NuoroMobileNavigation';
 menu.className = 'nuoro-menu';
 menu.setAttribute('aria-label', 'Menu NUORO');
 const arrow = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 6 6 6-6 6"/></svg>';
 menu.innerHTML = `<div class="nuoro-menu-promo" hidden></div>
  <header class="nuoro-menu-header">
   <button type="button" class="nuoro-menu-icon" data-close aria-label="Fermer le menu"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 6 12 12M6 18 18 6"/></svg></button>
   <a class="nuoro-menu-logo" href="/" aria-label="Accueil NUORO"><img src="${window.NuoroAsset('assets/logo-nuoro-black.png')}" alt="NUORO"></a>
   <div class="nuoro-menu-tools">
    <a class="nuoro-menu-icon" href="/a/account/login" aria-label="Mon compte"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 3.6-7 8-7s8 3 8 7"/></svg></a>
    <button class="nuoro-menu-icon" type="button" data-cart aria-label="Panier"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2.5 3h2.2l2.2 11.2a1.5 1.5 0 0 0 1.5 1.2h8.4a1.5 1.5 0 0 0 1.47-1.2L21 7H6"/></svg></button>
   </div>
  </header>
  <div class="nuoro-menu-panel">
   <nav aria-label="Navigation principale">
    <div class="nuoro-menu-primary">${[['Ingrédients','/pages/ingredients-et-benefices'],['Qualité','/pages/qualite'],['Notre mission','/pages/mission']].map(([label,url]) => `<a href="${url}"><span>${label}</span><span class="nuoro-menu-arrow">${arrow}</span></a>`).join('')}</div>
    <div class="nuoro-menu-secondary"><a href="/a/account/login">Mon compte</a><a href="/#faq" data-faq>FAQs</a><a href="/pages/assistance">Assistance</a></div>
   </nav>
   <footer class="nuoro-menu-footer">
    <div class="nuoro-menu-rating nuoro-trustpilot"><div class="trustpilot-widget"><a href="https://fr.trustpilot.com/review/drinknuoro.com" target="_blank" rel="noopener">Lire nos avis sur Trustpilot</a></div></div>
    <a class="nuoro-menu-cta" href="/#shop" data-shop>JE COMMENCE NUORO <span aria-hidden="true">→</span></a>
    <p class="nuoro-menu-guarantee"><span aria-hidden="true">✓</span> Satisfait ou remboursé 5 sticks</p>
   </footer>
  </div>`;
 document.body.append(menu);
 menu.querySelector('[data-close]').addEventListener('click', () => closeMobileMenu());
 menu.addEventListener('cancel', () => { menuRestoreFocus = true; });
 menu.addEventListener('close', () => {
  document.documentElement.style.overflow = menuPreviousOverflow;
  document.querySelectorAll('.nuoro-mobile-toggle,.nav-burger').forEach(button => button.setAttribute('aria-expanded', 'false'));
  if (menuRestoreFocus && menuTrigger?.isConnected) menuTrigger.focus({preventScroll: true});
  window.dispatchEvent(new Event('nuoro:navigationchange'));
 });
 menu.addEventListener('click', event => {
  if (event.target === menu) closeMobileMenu();
  const link = event.target.closest('a');
  if (!link) return;
  if (link.hasAttribute('data-shop')) {
   event.preventDefault(); closeMobileMenu(false); window.NuoroNavigation.goShop();
  } else if (link.hasAttribute('data-faq') && document.getElementById('faq')) {
   event.preventDefault(); closeMobileMenu(false);
   document.getElementById('faq').scrollIntoView({behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth'});
  } else if (link.target !== '_blank') closeMobileMenu(false);
 });
 menu.querySelector('[data-cart]').addEventListener('click', () => {
  closeMobileMenu(false);
  window.NuoroCommerce?.open(menuTrigger);
 });
 window.addEventListener('resize', () => { if (innerWidth >= 1024) closeMobileMenu(); });
 return menu;
}
window.NuoroNavigation = {
 goShop() {
  const shop = document.querySelector('#shop');
  if (shop) shop.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth'});
  else location.href = '/#shop';
 },
 openMenu(root) {
  if (innerWidth >= 1024) return;
  const menu = document.getElementById('NuoroMobileNavigation') || createMobileMenu();
  if (menu.open) return;
  menuTrigger = document.activeElement?.closest('.nuoro-mobile-toggle,.nav-burger') || root.querySelector('.nuoro-mobile-toggle,.nav-burger');
  menuRestoreFocus = true;
  menuPreviousOverflow = document.documentElement.style.overflow;
  const promo = root.dataset.nuoroModule === 'Hero' ? root.querySelector('.promo-strip') : null;
  const target = menu.querySelector('.nuoro-menu-promo');
  target.replaceChildren();
  if (promo) { target.innerHTML = promo.innerHTML; target.hidden = false; } else target.hidden = true;
  document.documentElement.style.overflow = 'hidden';
  menuTrigger?.setAttribute('aria-expanded', 'true');
  menuTrigger?.setAttribute('aria-controls', menu.id);
  menu.showModal();
  menu.querySelector('[data-close]').focus({preventScroll: true});
  window.NuoroTrustpilot?.init(menu);
  window.dispatchEvent(new Event('nuoro:navigationchange'));
 }
};
window.addEventListener('message',event=>{
 if(event.origin!==location.origin||event.source!==window)return;
 if(event.data?.nuoroGoShop)window.NuoroNavigation.goShop();
 if(typeof event.data?.nuoroScrollTo==='number')window.scrollTo({top:event.data.nuoroScrollTo,behavior:'smooth'});
});
document.addEventListener('shopify:section:load',()=>Object.keys(window.NuoroModules).forEach(window.NuoroBoot));
function setupShell(){
 const source=document.querySelector('.nuoro-module[data-nuoro-key="hero"],.nuoro-module[data-nuoro-key="nav"]');
 const sourceNav=source?.querySelector('.nav');
 if(!sourceNav||document.querySelector('.nuoro-sticky-nav'))return;
 const sticky=document.createElement('div');sticky.className='nuoro-sticky-nav';
 const module=document.createElement('div');module.className='nuoro-module';module.dataset.nuoroKey=source.dataset.nuoroKey;module.dataset.nuoroModule='Nav';module.dataset.nuoroReady='true';
 const hero=document.createElement('div');hero.className='hero';
 const nav=sourceNav.cloneNode(true);nav.querySelectorAll('[id]').forEach(el=>el.removeAttribute('id'));hero.append(nav);module.append(hero);sticky.append(module);document.body.append(sticky);
 sticky.addEventListener('click',event=>{
  if(event.target.closest('.nuoro-mobile-toggle,.nav-burger')){event.preventDefault();window.NuoroNavigation.openMenu(module);}
  else if(event.target.closest('[aria-label="Panier"]')){event.preventDefault();window.NuoroCommerce?.open(event.target);}
  else if(event.target.closest('[aria-label="Mon compte"]')){event.preventDefault();location.href='/a/account/login';}
  else if(event.target.closest('.nav-cta')){event.preventDefault();window.NuoroNavigation.goShop();}
 });
 const cta=document.createElement('button');cta.type='button';cta.className='nuoro-floating-cta';cta.innerHTML='Essayer Nuoro <svg class="fc-desktop-arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg><svg class="fc-mobile-arrow" viewBox="0 0 12 10" aria-hidden="true"><path d="M0 4.90112H9.91667M5.66667 9.15112L9.91667 4.90112L5.66667 0.651123"/></svg>';cta.addEventListener('click',()=>window.NuoroNavigation.goShop());document.body.append(cta);
 function positionFloatingCTA(){
  const viewport=window.visualViewport;
  const width=viewport?viewport.width:document.documentElement.clientWidth;
  const left=viewport?viewport.offsetLeft:0;
  const height=viewport?viewport.height:window.innerHeight;
  const top=viewport?viewport.offsetTop:0;
  cta.style.setProperty('--fc-visible-width',width+'px');
  cta.style.setProperty('--fc-hidden-right',Math.max(0,document.documentElement.clientWidth-left-width)+'px');
  cta.style.setProperty('--fc-hidden-bottom',Math.max(0,window.innerHeight-top-height)+'px');
 }
 positionFloatingCTA();
 window.addEventListener('resize',positionFloatingCTA,{passive:true});
 window.visualViewport?.addEventListener('resize',positionFloatingCTA,{passive:true});
 window.visualViewport?.addEventListener('scroll',positionFloatingCTA,{passive:true});
 function ensureMobileToggle(){
  if(innerWidth>=1024)return;
  [sourceNav,nav].forEach(header=>{
   if(header.querySelector('.nuoro-mobile-toggle,.nav-burger'))return;
   const toggle=document.createElement('button');toggle.type='button';toggle.className='nuoro-mobile-toggle';toggle.setAttribute('aria-label','Ouvrir le menu');toggle.setAttribute('aria-haspopup','dialog');toggle.setAttribute('aria-expanded','false');toggle.setAttribute('aria-controls','NuoroMobileNavigation');toggle.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 6h16M4 12h16M4 18h16"/></svg>';header.prepend(toggle);
   if(header===sourceNav)toggle.addEventListener('click',()=>window.NuoroNavigation.openMenu(source));
  });
 }
 ensureMobileToggle();window.addEventListener('resize',ensureMobileToggle,{passive:true});
 let lastY=window.scrollY;
 function sync(){
  const y=window.scrollY,heroEnd=source.getBoundingClientRect().bottom+y;
  const shop=document.getElementById('shop')?.getBoundingClientRect(),footer=document.getElementById('footer')?.getBoundingClientRect();
  const inShop=shop&&shop.top<innerHeight*.85&&shop.bottom>innerHeight*.15;
  const cartOpen=document.querySelector('cart-drawer.active,cart-drawer[open],.cart-drawer.active');
  const menuOpen=document.getElementById('NuoroMobileNavigation')?.open;
  if(y<heroEnd*.6||menuOpen||cartOpen){sticky.classList.remove('is-visible');cta.classList.remove('is-visible');}
  else{
   if(y<lastY-4)sticky.classList.add('is-visible');else if(y>lastY+4)sticky.classList.remove('is-visible');
   if(inShop||cartOpen||(footer&&footer.top<innerHeight))cta.classList.remove('is-visible');else if(y>lastY+2)cta.classList.add('is-visible');
  }
  sticky.inert=!sticky.classList.contains('is-visible');cta.tabIndex=cta.classList.contains('is-visible')?0:-1;lastY=y;
 }
 sticky.inert=true;cta.tabIndex=-1;window.addEventListener('scroll',sync,{passive:true});window.addEventListener('resize',sync,{passive:true});sync();
 window.addEventListener('nuoro:navigationchange',sync);
 const nativeCart=document.querySelector('cart-drawer');if(nativeCart)new MutationObserver(sync).observe(nativeCart,{attributes:true,attributeFilter:['class','open']});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setupShell,{once:true});else setupShell();

if(!customElements.get('image-slot')){
 const imageStyle=document.createElement('style');
 imageStyle.textContent='image-slot{display:inline-block;position:relative;overflow:hidden}image-slot>img{display:block;width:100%;height:100%;max-width:none;object-fit:cover;object-position:50% 50%}';
 document.head.appendChild(imageStyle);
 customElements.define('image-slot',class extends HTMLElement{
  connectedCallback(){
   let img=this.querySelector('img');
   if(!img){
    img=document.createElement('img');
    img.alt=this.getAttribute('alt')||this.getAttribute('placeholder')||'';
    img.loading='lazy';
    img.decoding='async';
    img.style.objectFit=this.getAttribute('fit')||'cover';
    window.NuoroResponsiveImage(img,this.getAttribute('src')||'',Math.ceil(this.getBoundingClientRect().width||300)+'px');
    this.appendChild(img);
   }
   imageSizer.observe(this);
  }
  disconnectedCallback(){imageSizer.unobserve(this);}
 });
}
})();
